export default "__VITE_ASSET__DyAt2i$m__"